<ng-container *ngIf="didYouMean">
  <span class="spelling-suggestion"
    >{{ 'customSearch.didYouMeanLabel' | cxTranslate
    }}<a [routerLink]="['/search/', didYouMean.suggestion]">{{ didYouMean.suggestion }}</a
    >?</span
  >
</ng-container>
<ng-container *ngIf="!didYouMean && searchBoxSuggestions && showSearchInstead(searchBoxSuggestions, searchBoxQuery)">
  <ul class="search-suggestion">
    {{
      'customSearch.searchBoxSuggestionsLabel' | cxTranslate
    }}
    <li *ngFor="let suggestion of searchBoxSuggestions">
      <a [routerLink]="['/search/', suggestion]">{{ suggestion }}</a>
    </li>
  </ul>
</ng-container>
